<script xmlns="http://www.w3.org/1999/html">
	import * as eggjson from './eggz.json';
	import * as tokenjson from './token.json';
	import * as contractjson from './contracts.json';
	import * as emitjson from './tung.json';
	import Web3 from "./web3.min";
	import { onMount } from 'svelte';
	import Chart from './Chart.svelte';
	import Leaderboard from './Leaderboard.svelte';
	import Modal from "./Modal.svelte";
	import detectEthereumProvider from '@metamask/detect-provider';
	import url from './url'
	let showRename = false;
	let showChangeEmission = false;
	let renameToken;
	let renameTokenNameInitial;
	let dropdownTrigger;
	let address = false;
	let connected = false;
	let chainId = false;
	let chain = false;
	let challenge = "";
	let response = false;
	let mode = false;
	let numMint = 1;
	let eggApprove =100;
	let tokenId = '';
	let valueRead = false;
	let tokenApproval = null;
	let eggApproval = null;
	let jlpBalance = 0;
	let mintPrice = 10;
	let mintLive = false;
	let minted = 0
	let totalSupply = 500
	let numberOwned = 0
	let ownedTokens = []
	let web3js = new Web3(window.ethereum);
	let baseURI = "https://api.eggz.chi.kn/api/"
	let lineBreak = false
	let tx_count = 0
	let nonce = 0;
	let oldnonce = -1;
	let ethConnected = false;
	let timestampNow = Math.floor(new Date().getTime() / 1000);
	let lbOffset = 0;
	let emitTokens = {
		0: "NONE",
		1: "TUNG",
		2: "BOXH",
		3: "DAFT",
		4: "MRCA",
		5: "GBD"
	}
	let burnValue = {
		tung: 0,
		boxh: 0,
		daft: 0,
		mrca: 0,
		gbd: 0,
	};
	let tokenBalances = {
		tung: 1,
		boxh: 1,
		daft: 1,
		mrca: 1,
		gbd: 1,
		egg: 1,
	}
	let burnedBalances = {
		tung: 1,
		boxh: 1,
		daft: 1,
		mrca: 1,
		gbd: 1,
	}

	let burnData = [0,0,0,0,0]

	const provider = async () => {
		await detectEthereumProvider();
		if(provider) {
			ethereum.on('accountsChanged', (accounts) => {
				nonce = 0;
				connectWallet()
			});
			ethereum.on('chainChanged', (chainId) => {
				connectWallet()
			});
		}
	}

	async function getApiEggzData() {
		let response = await fetch("https://api.eggz.chi.kn/stats/eggzdata");
		let eggzData = await response.json();
		return eggzData
	}

	const eggzPromise = getApiEggzData()

	async function connectWallet() {
		const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
		address = accounts[0];
		connected = ethereum.isConnected();
		chainId = ethereum.chainId;
	}

	async function getNonce() {
		nonce = await web3js.eth.getTransactionCount(address);
	}

	async function checkMintLive() {
		let newMintLive = await window.contract.methods.saleStarted().call()
		if(newMintLive !== mintLive){
			mintLive = newMintLive
		}
	}

	async function checkBaseURI() {
		let newBaseURI = await window.contract.methods.baseURI().call()
		if(newBaseURI !== baseURI){
			baseURI = newBaseURI
		}
	}

	async function checkAllowancesAndBalances() {
		if(oldnonce < nonce) {
			let newNumberOwned = await window.contract.methods.balanceOf(address).call()
			if(newNumberOwned !== numberOwned){
				numberOwned = newNumberOwned
				ownedTokens = []
				for (let x=0; x < numberOwned; x++) {
					ownedTokens.push(await window.contract.methods.tokenOfOwnerByIndex(address, x).call())
				}
				ownedTokens = ownedTokens;
			}
			tokenApproval = await window.token.methods.allowance(address, contractjson.eggz).call()
			eggApproval = Web3.utils.fromWei(await window.egg.methods.allowance(address, contractjson.eggz).call())
			tokenBalances.tung = await window.tung.methods.balanceOf(address).call()
			tokenBalances.boxh = await window.boxh.methods.balanceOf(address).call()
			tokenBalances.daft = await window.daft.methods.balanceOf(address).call()
			tokenBalances.mrca = await window.mrca.methods.balanceOf(address).call()
			tokenBalances.gbd = await window.gbd.methods.balanceOf(address).call()
			tokenBalances.egg = await window.egg.methods.balanceOf(address).call()
			burnedBalances.tung = await window.tung.methods.burnedByAddress(address).call()
			burnedBalances.boxh = await window.boxh.methods.burnedByAddress(address).call()
			burnedBalances.daft = await window.daft.methods.burnedByAddress(address).call()
			burnedBalances.mrca = await window.mrca.methods.burnedByAddress(address).call()
			burnedBalances.gbd = await window.gbd.methods.burnedByAddress(address).call()
			jlpBalance = await window.token.methods.balanceOf(address).call()
			oldnonce = nonce
		}
	}

	async function getBurnData() {
		let tungBurn = await window.tung.methods.totalBurned().call()
		let boxhBurn = await window.boxh.methods.totalBurned().call()
		let daftBurn = await window.daft.methods.totalBurned().call()
		let mrcaBurn = await window.mrca.methods.totalBurned().call()
		let gbdBurn = await window.gbd.methods.totalBurned().call()

		burnData = [
			Web3.utils.fromWei(tungBurn),
			Web3.utils.fromWei(boxhBurn),
			Web3.utils.fromWei(daftBurn),
			Web3.utils.fromWei(mrcaBurn),
			Web3.utils.fromWei(gbdBurn)
		]
	}

	async function getEggzData(tokenID){
		let eggData = await window.contract.methods.getEggzData(tokenID).call()
		let image = await getImage(tokenID)
		let unclaimed = await window.contract.methods.getUnclaimed(tokenID).call()
		return{
			kg: eggData[0],
			emits: eggData[1],
			lastClaimed: eggData[2],
			name: eggData[3],
			upgradeNoEarlierThan: eggData[4],
			image: image,
			unclaimed: unclaimed
		}
	}

	async function renameClickHandler(_tokenID, _name) {
		renameToken = _tokenID;
		renameTokenNameInitial = _name;
		showRename = true;
	}

	async function emissionClickHandler(_tokenID, _emits) {
		renameToken = _tokenID;
		renameTokenNameInitial = _emits;
		showChangeEmission = true;
	}

	async function checkTotalSupply() {
		let newMinted = await window.contract.methods.totalSupply().call()
		if(newMinted !== minted){
			minted = newMinted
		}
	}
	async function getImage(tokenID){
		if(tokenID >= 0) {
			let response = await fetch(baseURI + tokenID);
			let tokenMeta = await response.json();
			return tokenMeta['image'];
		}
		return "https://api.eggz.chi.kn/image/animated.gif"
	}

	async function eggMint() {
		let price = (0).toString();
		const transactionParameters = {
			to: contractjson.eggz,
			from: address,
			'data': window.contract.methods.mint(numMint).encodeABI()
		};
		try {
			const txHash = await window.ethereum
					.request({
						method: 'eth_sendTransaction',
						params: [transactionParameters],
					});
			return {
				success: true,
				status: "✅ Check out your transaction on Etherscan: https://ropsten.etherscan.io/tx/" + txHash
			}
		} catch (error) {
			console.log(error.message)
			return {
				success: false,
				status: "😥 Something went wrong: " + error.message
			}
		}
	}

	async function burnToken(token, burnAmount) {
		let burnData;
		let amount = Web3.utils.toWei(burnAmount);
		let contractTo;

		if (token === 'tung') {
			burnData = window.tung.methods.burnToken(amount).encodeABI()
			contractTo = contractjson.tung
		} else if (token === 'boxh') {
			burnData = window.boxh.methods.burnToken(amount).encodeABI()
			contractTo = contractjson.boxh
		} else if (token === 'daft') {
			burnData = window.daft.methods.burnToken(amount).encodeABI()
			contractTo = contractjson.daft
		} else if (token === 'mrca') {
			burnData = window.mrca.methods.burnToken(amount).encodeABI()
			contractTo = contractjson.mrca
		} else if (token === 'gbd') {
			burnData = window.gbd.methods.burnToken(amount).encodeABI()
			contractTo = contractjson.gbd
		}
		const transactionParameters = {
			to: contractTo,
			from: address,
			'data': burnData
		};
		try {
			const txHash = await window.ethereum
					.request({
						method: 'eth_sendTransaction',
						params: [transactionParameters],
					});
			return {
				success: true,
				status: "✅ Check out your transaction on Etherscan: https://ropsten.etherscan.io/tx/" + txHash
			}
		} catch (error) {
			console.log(error.message)
			return {
				success: false,
				status: "😥 Something went wrong: " + error.message
			}
		}
	}

	async function eggApprover() {
		let approval = Web3.utils.toWei(String(eggApprove))
		const transactionParameters = {
			to: contractjson.egg,
			from: address,
			'data': window.egg.methods.approve(contractjson.eggz, (approval).toString()).encodeABI()
		};
		try {
			const txHash = await window.ethereum
					.request({
						method: 'eth_sendTransaction',
						params: [transactionParameters],
					});
			return {
				success: true,
				status: "✅ Check out your transaction on Etherscan: https://ropsten.etherscan.io/tx/" + txHash
			}
		} catch (error) {
			console.log(error.message)
			return {
				success: false,
				status: "😥 Something went wrong: " + error.message
			}
		}
	}

	async function tokenApprove() {
		let approval = Web3.utils.toWei(String(numMint * mintPrice))
		const transactionParameters = {
			to: contractjson.jlp,
			from: address,
			'data': window.token.methods.approve(contractjson.eggz, (approval).toString()).encodeABI()
		};
		try {
			const txHash = await window.ethereum
					.request({
						method: 'eth_sendTransaction',
						params: [transactionParameters],
					});
			return {
				success: true,
				status: "✅ Check out your transaction on Etherscan: https://ropsten.etherscan.io/tx/" + txHash
			}
		} catch (error) {
			console.log(error.message)
			return {
				success: false,
				status: "😥 Something went wrong: " + error.message
			}
		}
	}

	async function renameEggz(_tokenID, _newName) {
		const transactionParameters = {
			to: contractjson.eggz,
			from: address,
			'data': window.contract.methods.renameEggz(_tokenID, _newName).encodeABI()
		}
		try {
			const txHash = await window.ethereum.request(
					{
						method: 'eth_sendTransaction',
						params: [transactionParameters]
					}
			);
			showRename = false;
			return {
				success: true,
				status: "well done ;)"
			}
		} catch (error) {
			console.log(error.message)
			return {
				success: false,
				status: "something went wrong"
			}
		}
	}

	async function upgradeEggz(eggzID) {
		const transactionParameters = {
			to: contractjson.eggz,
			from: address,
			'data': window.contract.methods.upgradeEggz(eggzID).encodeABI()
		}
		try {
			const txHash = await window.ethereum.request(
					{
						method: 'eth_sendTransaction',
						params: [transactionParameters]
					}
			);
			return {
				success: true,
				status: "well done ;)"
			}
		} catch (error) {
			console.log(error.message)
			return {
				success: false,
				status: "something went wrong"
			}
		}
	}

	async function changeEmission(eggzID, emissionID) {
		const transactionParameters = {
			to: contractjson.eggz,
			from: address,
			'data': window.contract.methods.setEmissionToken(eggzID, emissionID).encodeABI()
		}
		try {
			const txHash = await window.ethereum.request(
					{
						method: 'eth_sendTransaction',
						params: [transactionParameters]
					}
			);
			return {
				success: true,
				status: "well done ;)"
			}
		} catch (error) {
			console.log(error.message)
			return {
				success: false,
				status: "something went wrong"
			}
		}
	}

	async function updateTimestampNow() {
		timestampNow = Math.floor(new Date().getTime() / 1000)
	}

	async function setMax(token) {
		switch(token) {
			case 'tung':
				burnValue.tung = Web3.utils.fromWei(tokenBalances[token]);
				break;
			case 'boxh':
				burnValue.boxh = Web3.utils.fromWei(tokenBalances[token]);
				break;
			case 'daft':
				burnValue.daft = Web3.utils.fromWei(tokenBalances[token]);
				break;
			case 'mrca':
				burnValue.mrca = Web3.utils.fromWei(tokenBalances[token]);
				break;
			case 'gbd':
				burnValue.gbd = Web3.utils.fromWei(tokenBalances[token]);
				break;
		}
	}

	async function claimTokens(eggzID, emitToken) {
		let s = emitToken.toLowerCase();
		if (s === '1') {
			const transactionParameters = {
				to: contractjson.tung,
				from: address,
				'data': window.tung.methods.claimByEggz(eggzID).encodeABI()
			}
			try {
				const txHash = await window.ethereum.request(
						{
							method: 'eth_sendTransaction',
							params: [transactionParameters]
						}
				);
				return {
					success: true,
					status: "well done ;)"
				}
			} catch (error) {
				console.log(error.message)
				return {
					success: false,
					status: "something went wrong"
				}
			}
		} else if (s === '2') {
			const transactionParameters = {
				to: contractjson.boxh,
				from: address,
				'data': window.boxh.methods.claimByEggz(eggzID).encodeABI()
			}
			try {
				const txHash = await window.ethereum.request(
						{
							method: 'eth_sendTransaction',
							params: [transactionParameters]
						}
				);
				return {
					success: true,
					status: "well done ;)"
				}
			} catch (error) {
				console.log(error.message)
				return {
					success: false,
					status: "something went wrong"
				}
			}
		} else if (s === '3') {
			const transactionParameters = {
				to: contractjson.daft,
				from: address,
				'data': window.daft.methods.claimByEggz(eggzID).encodeABI()
			}
			try {
				const txHash = await window.ethereum.request(
						{
							method: 'eth_sendTransaction',
							params: [transactionParameters]
						}
				);
				return {
					success: true,
					status: "well done ;)"
				}
			} catch (error) {
				console.log(error.message)
				return {
					success: false,
					status: "something went wrong"
				}
			}
		} else if (s === '4') {
			const transactionParameters = {
				to: contractjson.mrca,
				from: address,
				'data': window.mrca.methods.claimByEggz(eggzID).encodeABI()
			}
			try {
				const txHash = await window.ethereum.request(
						{
							method: 'eth_sendTransaction',
							params: [transactionParameters]
						}
				);
				return {
					success: true,
					status: "well done ;)"
				}
			} catch (error) {
				console.log(error.message)
				return {
					success: false,
					status: "something went wrong"
				}
			}
		} else if (s === '5') {
			const transactionParameters = {
				to: contractjson.gbd,
				from: address,
				'data': window.gbd.methods.claimByEggz(eggzID).encodeABI()
			}
			try {
				const txHash = await window.ethereum.request(
						{
							method: 'eth_sendTransaction',
							params: [transactionParameters]
						}
				);
				return {
					success: true,
					status: "well done ;)"
				}
			} catch (error) {
				console.log(error.message)
				return {
					success: false,
					status: "something went wrong"
				}
			}
		}
	}

	onMount(async () => {
		if (provider) {
			await connectWallet();
			window.contract = await new web3js.eth.Contract(eggjson.abi, contractjson.eggz);
			window.token = await new web3js.eth.Contract(tokenjson.abi, contractjson.jlp);
			window.egg = await new web3js.eth.Contract(tokenjson.abi, contractjson.egg);
			window.tung = await new web3js.eth.Contract(emitjson.abi, contractjson.tung);
			window.boxh = await new web3js.eth.Contract(emitjson.abi, contractjson.boxh);
			window.daft = await new web3js.eth.Contract(emitjson.abi, contractjson.daft);
			window.mrca = await new web3js.eth.Contract(emitjson.abi, contractjson.mrca);
			window.gbd = await new web3js.eth.Contract(emitjson.abi, contractjson.gbd);
			const mintInterval = setInterval(checkTotalSupply, 10000);
			const liveInterval = setInterval(checkMintLive, 10000);
			const timestampInterval = setInterval(updateTimestampNow, 30000);
			const nonceInterval = setInterval(getNonce, 5000);
			const tokenBalanceInterval = setInterval(checkAllowancesAndBalances, 10000);
			const burnDataInterval = setInterval(getBurnData, 60000)
			checkMintLive();
			checkTotalSupply();
			checkBaseURI();
			getNonce();
			checkAllowancesAndBalances();
			getBurnData();
			return () => {
				clearInterval(mintInterval)
				clearInterval(liveInterval)
				clearInterval(timestampInterval)
				clearInterval(nonceInterval)
				clearInterval(tokenBalanceInterval)
				clearInterval(burnDataInterval)
			}
		}
	}
	)
</script>

<div id="app">
	<header class="eggzheader text-secondary">
		<div class="flex sm:text-5xl text-accent font-extrabold text-bold">
			<a href="#/" class="{$url.hash === '/' ? 'text-accent' : ''} nb">EGGZ</a>
		</div>
		<div class="flex gap-5">
			<div>
				<a href="#/leaderboard" class="{$url.hash === '#/leaderboard' ? 'text-accent' : ''} nb">LEADERBOARD</a>
			</div>
			<div class="">
				<a href="#/tokenburn" class="{$url.hash === '#/tokenburn' ? 'text-accent' : ''} nb">BURN</a>
			</div>
<!--			<div>-->
<!--				<a href="#/mint" class="{$url.hash === '#/mint' ? 'text-accent' : ''} nb">MINT</a>-->
<!--			</div>-->
			<div>
				<a href="#/my_eggz" class="{$url.hash === '#/my_eggz' ? 'text-accent' : ''} nb">MY EGGZ ({numberOwned})</a>
			</div>
			<div class="address">{address}</div>
		</div>
	</header>
		{#key chainId}
		<main class="content-center w-full h-full pt px-10">
			<div class="max-w-screen-xl container mx-auto">
				{#if $url.hash === '' || $url.hash === '#/'}
					<section class="bg-header rounded-lg p-4">
						<div class="bg-background w-full rounded-lg p-4 text-center">
							<div class="text-3xl sm:text-5xl font-extrabold text-accent text-bold py-1 flex justify-center">
								<div>
									Welcome To EGGZ!!!
								</div>
							</div>
							<div class="text-3xl sm:text-3xl font-extrabold text-secondary gap-2 text-bold py-1">
								A <span class="text-accent">Community Project</span> To Determine The Best <span class="text-accent">Legendary chikn Head Trait</span>
							</div>
							<div class="text-accent text-italic">
								**Please note that this is a third party project and in no way associated with Chikn**
							</div>
						</div>
						<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
							<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
								<div>
									<div class="text-secondary gap-2 py-1">
										Everybody knows <span class="text-accent">chikn</span> lay <span class="text-accent">$EGG</span>, but <span class="text-accent">EGGZ</span> are a little different :)
									</div>
									<div class="text-secondary gap-2 py-1">
										<img class="eggimage" src="https://api.eggz.chi.kn/image/animated.gif">
									</div>
									<br>
									<div class="text-accent gap-2 py-1">
										PROJECT DETAILS
									</div>
									<br><hr class="hr-25"><br>
									<div class="text-secondary gap-2 py-1">
										A Series of <span class="text-accent">500</span> AI Generated <span class="text-accent">EGGZ</span> NFTs on Avalanche
									</div>
									<div class="text-secondary gap-2 py-1">
										<span class="text-accent">EGGZ</span> are minted with <span class="text-accent">EGG/AVAX JLP BURN</span> - To lock liquidity into the <span class="text-accent">chikn</span> eggosystem
									</div>
									<div class="text-secondary gap-2 py-1">
										Cost of MINT: <span class="text-accent">10 JLP</span> - MINTED OUT
									</div>
									<div class="text-secondary gap-2 py-1">
										Available on Secondary Market: <span class="text-accent"><a href="https://joepegs.com/collections/eggz">Joepegs</a></span>
									</div>
									<br><hr class="hr-25"><br>
									<div class="text-secondary gap-2 py-1">
										<span class="text-accent">EGGZ</span> are upgradeable <span class="text-accent">NFTs</span> that Emit one of 5 <span class="text-accent">ERC20</span> Tokens
									</div>
									<div class="text-secondary gap-2 py-1">
										<span class="text-accent">$TUNG</span>, <span class="text-accent">$BOXH</span>, <span class="text-accent">$DAFT</span>, <span class="text-accent">$MRCA</span>, or <span class="text-accent">$GBD</span>
									</div>
									<div class="text-secondary gap-2 py-1">
										One for each of the legendary <span class="text-accent">chikn</span> head traits
									</div>
									<br><hr class="hr-25"><br>
									<div class="text-secondary gap-2 py-1">
										UPGRADEABLE ATTRIBUTES
									</div>
									<div class="text-secondary gap-2 py-1">
										<span class="text-accent">KG</span> - The Weight of your <span class="text-accent">EGGZ</span> determines the emission rate of the trait token. 1 per day, per KG
									</div>
									<div class="text-secondary gap-2 py-1">
										<span class="text-accent">Emission</span> - The token that your <span class="text-accent">EGGZ</span> produces
									</div>
									<div class="text-secondary gap-2 py-1">
										<span class="text-accent">Name</span> - Give your <span class="text-accent">EGGZ</span> a name
									</div>
									<br><hr class="hr-25"><br>
									<div class="text-secondary gap-2 py-1">
										BURN MECHANICS
									</div>
									<div class="text-secondary gap-2 py-1">
										BURN <span class="text-accent">JLP</span> - MINT your <span class="text-accent">EGGZ</span>
									</div>
									<div class="text-secondary gap-2 py-1">
										BURN <span class="text-accent">$EGG</span> - Increase your <span class="text-accent">EGGZ</span> KG
									</div>
									<div class="text-secondary gap-2 py-1">
										BURN <span class="text-accent">$EGG</span> - Give your <span class="text-accent">EGGZ</span> a name
									</div>
									<div class="text-secondary gap-2 py-1">
										BURN <span class="text-accent">$EGG</span> - Switch your <span class="text-accent">EGGZ</span> emission token
									</div>
									<div class="text-secondary gap-2 py-1">
										BURN <span class="text-accent">$TUNG</span>, <span class="text-accent">$BOXH</span>, <span class="text-accent">$DAFT</span>, <span class="text-accent">$MRCA</span>, or <span class="text-accent">$GBD</span> - Cast your votes for that #1 legendary <span class="text-accent">chikn</span> head trait!
									</div>
								</div>
							</div>
						</section>
					</section>
				{:else}
					{#if address !== false && chainId === '0xa86a'}
					{#if $url.hash === '#/my_eggz'}
						{#key nonce}
							<section class="bg-header rounded-lg p-4">
								<div class="bg-background w-full rounded-lg p-4 text-center">
									<div class="text-3xl sm:text-5xl font-extrabold text-accent text-bold py-1 flex justify-center">
										<div>
											MY EGGZ ({numberOwned})
										</div>
									</div>
									<div class="text-3xl sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
										<span>
											$EGG Balance:
										</span>
										<span class="text-secondary">
											{#if tokenBalances.egg > 1}
												{Web3.utils.fromWei(tokenBalances.egg)}
											{/if}
										</span>
									</div>
									<div class="text-3xl sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
										<span>
											Approved $EGG:
										</span>
										<span class="text-secondary">
											{eggApproval}
										</span>
									</div>
									<span class="text-secondary">-----</span>
									<div>
										<button on:click="{eggApprover}" class="approvebtn claim">Approve {eggApprove} $EGG</button>
									</div>
									<div>
										<input type=range bind:value={eggApprove} min=0 max=1000 step=2 class="py-1 slider_width">
									</div>
									<div class="text-accent text-italic">
										**Please note you need to approve $EGG to interact with your EGGZ**
									</div>
									<div class="text-secondary text-italic">
										Rename: 20 $EGG BURN
									</div>
									<div class="text-secondary text-italic">
										Increase Size: KG^2 $EGG BURN
									</div>
									<div class="text-secondary text-italic">
										Change Emission Token: 10$EGG BURN
									</div>
								</div>
								{#each ownedTokens as ownedToken}
									{#await getEggzData(ownedToken)}
										{:then items}
											<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
												<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
													<div class="flex-child">
														<img src="{items.image}" class="eggimage">
													</div>
													<div class="flex-child ta-left">
														<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
															<span>
																EGGZ #:
															</span>
															<span class="text-secondary">
																{ownedToken}
															</span>
														</div>
														<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
															<span>
																Eggz Name:
															</span>
															<span class="text-secondary">
																{items.name}
															</span>
														</div>
														<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
															<span>
																Weight:
															</span>
															<span class="text-secondary">
																{items.kg} KG
															</span>
														</div>
														<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
															<span>
																Emits:
															</span>
															<span class="text-secondary">
																{#if emitTokens[items.emits] !== 'NONE'}
																	${emitTokens[items.emits]}
																{:else}
																	Please Set Emission Token
																{/if}
															</span>
														</div>
														<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
															<span>
																Unclaimed:
															</span>
															<span class="text-secondary">
																~{Number(Web3.utils.fromWei(items.unclaimed)).toFixed(4)} {emitTokens[items.emits]}
															</span>
														</div>
														<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
															<span>
																Upgrade Available In:
															</span>
															<span class="text-secondary">
																{#if (items.upgradeNoEarlierThan > timestampNow)}
																	{new Date((items.upgradeNoEarlierThan - timestampNow)*1000).toISOString().substring(11, 16)}
																{:else}
																	NOW!!
																{/if}
															</span>
														</div>
														<div class="flex">
															{#if '0' !== items.emits}
																<button on:click="{claimTokens(ownedToken, items.emits)}" class="btn claim">Claim ${emitTokens[items.emits]}</button>
															{:else}
																<button class="btndis claim" disabled>Emission Not Set</button>
															{/if}
															{#if items.kg * items.kg < eggApproval && (items.upgradeNoEarlierThan < Math.floor(new Date().getTime() / 1000))}
																<button on:click="{upgradeEggz(ownedToken)}" class="btn claim">+KG ({items.kg * items.kg} $EGG)</button>
															{:else}
																<button on:click="{upgradeEggz(ownedToken)}" class="btndis claim" disabled>Increase KG</button>
															{/if}
														</div>
														<div class="flex">
															{#if eggApproval < 10}
																<button class="btndis claim" disabled>Change Emission</button>
															{:else}
																<button on:click="{emissionClickHandler(ownedToken, items.emits)}" class="btn claim">Change Emission</button>
															{/if}
															{#if eggApproval < 20}
																<button class="btndis claim" disabled>Rename EGGZ</button>
															{:else}
																<button on:click="{renameClickHandler(ownedToken, items.name)}" class="btn claim">Rename EGGZ</button>
															{/if}
														</div>
													</div>
												</div>
											</section>
										{/await}
									{/each}
							</section>
							{/key}
					{:else if $url.hash === '#/mint'}
						<section class="bg-header rounded-lg p-4">
							<div class="bg-background w-full rounded-lg p-4 text-center">
								<div class="text-3xl sm:text-5xl font-extrabold text-accent text-bold py-1 flex justify-center">
									<div>
										MINT SOME EGGZ
									</div>
								</div>
							</div>
							<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
								<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
									<div>
										<div class="text-accent gap-2 py-1">
											Mint Status:
											<span class="text-secondary">
												Minted Out!
											</span>
										</div>
										<div class="text-accent gap-2 py-1">
											Total Minted:
											<span class="text-secondary">
												{minted}/{totalSupply}
											</span>
										</div>
										<div class="flex justify-center text-secondary">
											-----
										</div>
										<div class="text-accent gap-2 py-1">
											Mint Cost:
											<span class="text-secondary">
												10 EGG/AVAX JLP
											</span>
										</div>
										<div class="text-accent gap-2 py-1">
											<span>
												Max Mint per TX:
											</span>
											<span class="text-secondary">
												3
											</span>
										</div>
									</div>
								</div>
							</section>
							<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
								<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
									<div>
										<div class="text-accent gap-2 py-1">
											Your JLP Balance:
											<span class="text-secondary">
												{#if jlpBalance > 10}
													{Web3.utils.fromWei(jlpBalance)}
												{/if}
											</span>
										</div>
										<div class="text-accent gap-2 py-1">
											Number of EGGZ to mint with JLP BURN:
											<span class="text-secondary">
												{numMint}
											</span>
										</div>
										<div class="text-accent gap-2 py-1">
											<input type=range bind:value={numMint} min=1 max=3 class="rs">
										</div>
										<div class="flex justify-center">
											{#if tokenApproval}
												{#if Web3.utils.fromWei(tokenApproval) < numMint * mintPrice}
													<button on:click="{tokenApprove}" class="btn claim">Approve {numMint * mintPrice} JLP</button>
													<button on:click="{eggMint}" disabled class="btndis claim">Mint</button>
												{:else}
													<button on:click="{tokenApprove}" class="btndis claim" disabled>${Web3.utils.fromWei(tokenApproval)} JLP Approved</button>
													<button on:click="{eggMint}" class="btn claim">Mint</button>
												{/if}
											{/if}
										</div>
									</div>
								</div>
							</section>
							<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
								<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
									<div>
										<div class="text-accent gap-2 py-1">
											Last 5 Minted EGGZ
										</div>
										<div class="flex oh">
										{#each Array(5) as _, i}
											{#await getImage(minted-i-1)}
												{:then items}
												<img src="{items}" width="100" class="mintedimage">
											{/await}
										{/each}
										</div>
									</div>
								</div>
							</section>
						</section>
					{:else if $url.hash === '#/tokenburn'}
						{#key nonce}
							<section class="bg-header rounded-lg p-4">
								<div class="bg-background w-full rounded-lg p-4 text-center">
									<div class="text-3xl sm:text-5xl font-extrabold text-accent text-bold py-1 flex justify-center">
										<div>
											BURN LEADERBOARD
										</div>
									</div>
								</div>
								<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
									<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
										<Chart {burnData} />
									</div>
								</section>
							</section>
							<br><br>
							<section class="bg-header rounded-lg p-4">
								<div class="bg-background w-full rounded-lg p-4 text-center">
									<div class="text-3xl sm:text-5xl font-extrabold text-accent text-bold py-1 flex justify-center">
										<div>
											BURN SOME TOKENS
										</div>
									</div>
								</div>
								<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
									<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
										<div>
											<div class="text-accent gap-2 py-1">
												$TUNG Balance:
												<span class="text-secondary">
													{Number(Web3.utils.fromWei(String(tokenBalances.tung))).toFixed(4)}
												</span>
												<span class="text-accent">(</span>
												<span class="text-secondary">{Number(Web3.utils.fromWei(String(burnedBalances.tung))).toFixed(4)}</span>
												<span class="text-accent">Burned )</span>
											</div>
											<div class="text-accent gap-2 py-1">
												$BOXH Balance:
												<span class="text-secondary">
														{Number(Web3.utils.fromWei(String(tokenBalances.boxh))).toFixed(4)}
												</span>
												<span class="text-accent">(</span>
												<span class="text-secondary">{Number(Web3.utils.fromWei(String(burnedBalances.boxh))).toFixed(4)}</span>
												<span class="text-accent">Burned )</span>
											</div>
											<div class="text-accent gap-2 py-1">
												$DAFT Balance:
												<span class="text-secondary">
														{Number(Web3.utils.fromWei(String(tokenBalances.daft))).toFixed(4)}
												</span>
												<span class="text-accent">(</span>
												<span class="text-secondary">{Number(Web3.utils.fromWei(String(burnedBalances.daft))).toFixed(4)}</span>
												<span class="text-accent">Burned )</span>
											</div>
											<div class="text-accent gap-2 py-1">
												$MRCA Balance:
												<span class="text-secondary">
														{Number(Web3.utils.fromWei(String(tokenBalances.mrca))).toFixed(4)}
												</span>
												<span class="text-accent">(</span>
												<span class="text-secondary">{Number(Web3.utils.fromWei(String(burnedBalances.mrca))).toFixed(4)}</span>
												<span class="text-accent">Burned )</span>
											</div>
											<div class="text-accent gap-2 py-1">
												$GBD Balance:
												<span class="text-secondary">
														{Number(Web3.utils.fromWei(String(tokenBalances.gbd))).toFixed(4)}
												</span>
												<span class="text-accent">(</span>
												<span class="text-secondary">{Number(Web3.utils.fromWei(String(burnedBalances.gbd))).toFixed(4)}</span>
												<span class="text-accent">Burned )</span>
											</div>
										</div>
									</div>
								</section>
								<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
									<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
										<div>
											<div class="text-accent gap-2 py-1">
												<button on:click={() => setMax("tung")} class="approvebtn claim">MAX</button>
												<span class="text-secondary">
														<input bind:value="{burnValue.tung}" class="input-burn">
												</span>
												<button on:click={burnToken('tung', burnValue.tung)} class="approvebtn claim burn">BURN $TUNG</button>
											</div>
											<div class="text-accent gap-2 py-1">
												<button on:click={() => setMax("boxh")} class="approvebtn claim">MAX</button>
												<span class="text-secondary">
														<input bind:value="{burnValue.boxh}" class="input-burn">
												</span>
												<button on:click={burnToken('boxh', burnValue.boxh)} class="approvebtn claim burn">BURN $BOXH</button>
											</div>
											<div class="text-accent gap-2 py-1">
												<button on:click={() => setMax("daft")} class="approvebtn claim">MAX</button>
												<span class="text-secondary">
														<input bind:value="{burnValue.daft}" class="input-burn">
												</span>
												<button on:click={burnToken('daft', burnValue.daft)} class="approvebtn claim burn">BURN $DAFT</button>
											</div>
											<div class="text-accent gap-2 py-1">
												<button on:click={() => setMax("mrca")} class="approvebtn claim">MAX</button>
												<span class="text-secondary">
														<input bind:value="{burnValue.mrca}" class="input-burn">
												</span>
												<button on:click={burnToken('mrca', burnValue.mrca)} class="approvebtn claim burn">BURN $MRCA</button>
											</div>
											<div class="text-accent gap-2 py-1">
												<button on:click={() => setMax("gbd")} class="approvebtn claim">MAX</button>
												<span class="text-secondary">
														<input bind:value="{burnValue.gbd}" class="input-burn">
												</span>
												<button on:click={burnToken('gbd', burnValue.gbd)} class="approvebtn claim burn">BURN $GBD</button>
											</div>
										</div>
									</div>
								</section>
							</section>
						{/key}
					{:else if $url.hash === '#/leaderboard'}
						<Leaderboard/>
					{/if}
					{#if showRename}
						<Modal on:close="{() => showRename = false}">
							<section class="flex lg:flex-row flex-col">
								<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
									<div class="flex-child">
										<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
											RENAME EGGZ
											<span class="text-secondary">#{renameToken}</span>
										</div>
										<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
											<input type="text" bind:value={renameTokenNameInitial} class="input-rename" maxlength="24">
										</div>
										<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
											<button on:click={renameEggz(renameToken, renameTokenNameInitial)} class="btn claim">Rename EGGZ #{renameToken}</button>
										</div>
									</div>
								</div>
							</section>
						</Modal>
					{/if}
					{#if showChangeEmission}
						<Modal on:close="{() => showChangeEmission= false}">
							<section class="flex lg:flex-row flex-col">
								<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
									<div class="flex-child">
										<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
											Change EGGZ Emission
											<span class="text-secondary">#{renameToken}</span>
										</div>
										<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
											{#if renameTokenNameInitial === "1"}
												<button on:click="{changeEmission(renameToken, 1)}" class="btn claim" type="button" disabled>$TUNG</button>
											{:else}
												<button on:click="{changeEmission(renameToken, 1)}" class="btn claim" type="button">$TUNG</button>
											{/if}
											{#if renameTokenNameInitial === "2"}
												<button on:click="{changeEmission(renameToken, 2)}" class="btn claim" type="button" disabled>$BOXH</button>
											{:else}
												<button on:click="{changeEmission(renameToken, 2)}" class="btn claim" type="button">$BOXH</button>
											{/if}
										</div>
										<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
											{#if renameTokenNameInitial === "3"}
												<button on:click="{changeEmission(renameToken, 3)}" class="btn claim" type="button" disabled>$DAFT</button>
											{:else}
												<button on:click="{changeEmission(renameToken, 3)}" class="btn claim" type="button">$DAFT</button>
											{/if}
											{#if renameTokenNameInitial === "4"}
												<button on:click="{changeEmission(renameToken, 4)}" class="btn claim" type="button" disabled>$MRCA</button>
											{:else}
												<button on:click="{changeEmission(renameToken, 4)}" class="btn claim" type="button">$MRCA</button>
											{/if}
										</div>
										<div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
											{#if renameTokenNameInitial === "5"}
												<button on:click="{changeEmission(renameToken, 5)}" class="btn claim" type="button" disabled>$GBD</button>
											{:else}
												<button on:click="{changeEmission(renameToken, 5)}" class="btn claim" type="button">$GBD</button>
											{/if}
										</div>
									</div>
								</div>
							</section>
						</Modal>
					{/if}
				{:else}
						<section class="bg-header rounded-lg p-4">
					<div class="bg-background w-full rounded-lg p-4 text-center">
						<div class="text-3xl sm:text-5xl font-extrabold text-accent text-bold py-1 flex justify-center">
							<div>
								Please Connect!!
							</div>
						</div>
					</div>
					<section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
						<div class="bg-background w-full rounded-lg p-4 text-center flex-container">
							<span class="text-accent">Please Connect Your MetaMask Wallet To Avax Mainnet!</span>
						</div>
					</section>
				</section>
				{/if}
			{/if}
		</div>
	</main>
	{/key}
</div>
